import React, { Component } from 'react';

import firebase_connection from './backend/firebase';
import firebase from 'firebase';
import { Switch,Route } from 'react-router-dom';
import Header from './components/Header'
import Main from './components/Main'
import Organisation from './components/Organisation'
import Board from './components/Board'

import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';

import error_handler from './ErrorHandler'

const login_box_style = {
    display: 'inline-block',
    margin: '16px 32px 16px 0',
    position: 'fixed',
    top: '50%',
    left: '50%',
    'marginTop': '-50px',
    'marginLeft': '-100px',
};



class Login extends Component {
    loginWithGoogle = () => {
        this.props.setLoggingInTo("Google");
        let provider = new firebase.auth.GoogleAuthProvider();
        this.props.auth.signInWithPopup(provider);
    };

    loginWithTwitter = () => {
        this.props.setLoggingInTo("Twitter");
        let provider = new firebase.auth.TwitterAuthProvider();
        this.props.auth.signInWithPopup(provider);
    };

    loginWithFacebook = () => {
        this.props.setLoggingInTo("Facebook");
        let provider = new firebase.auth.FacebookAuthProvider();
        this.props.auth.signInWithPopup(provider);
    };

    render = () => {
        return (
            <Paper style={login_box_style}>
                <Menu>
                    <MenuItem onClick={this.loginWithGoogle} primaryText="Login using Google"/>
                    <MenuItem onClick={this.loginWithTwitter} primaryText="Login using Twitter"/>
                    <MenuItem onClick={this.loginWithFacebook} primaryText="Login using Facebook"/>
                </Menu>
            </Paper>
        )
    }
}

class App extends Component {
    constructor(props) {
        super(props);
        this.auth = firebase_connection.auth();
        this.auth.onAuthStateChanged(this.onAuthStateChanged,error_handler);
        this.state = {
            user : null,
            loggingIn : null
        }
    }

    onAuthStateChanged = (user) => {
        if (user) {
            this.setState({ user: user, loggingIn : null});
        } else {
            this.setState({ user: null, loggingIn : null});
        }
    };

    setLoggingInTo = (value) => {
        this.setState({ loggingIn : value});
    }

    render() {
        if (this.state.loggingIn) {
            return (
                <div style={login_box_style}><CircularProgress/>&nbsp;Logging in with {this.state.loggingIn}</div>
            )
        }
        else
            if (this.state.user) {
                return (
                    <div>
                        <Header auth={this.auth} user={this.state.user}/>
                        <Switch>
                            <Route exact path='/' render={props => (<Main {...props} user={this.state.user}/>)} />
                            <Route path='/:orgID/:boardID' component={Board}/>
                            <Route path='/:orgID' component={Organisation}/>
                        </Switch>
                    </div>
                );
            }
            else {
                return (<Login auth={this.auth} setLoggingInTo={this.setLoggingInTo}/>);
            }
    }

}

export default App;


// WEBPACK FOOTER //
// ./src/App.js